import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { getSite, siteToLang } from '../utils/url_parser'
import { translationMessages } from '../utils/i18n_react'

const LanguageContext = React.createContext()
export const LanguageContextProvider = LanguageContext.Provider
export const LanguageContextConsumer = LanguageContext.Consumer

class LanguageProvider extends React.PureComponent {
  constructor (props) {
    super(props)
    const site = getSite()
    const locale = siteToLang(site)
    this.state = {
      site: site || 'us',
      locale: locale || 'en'
    }
  }

  render () {
    const { locale, site } = this.state
    const { children } = this.props
    return (
      <IntlProvider
        locale={locale}
        key={locale}
        messages={translationMessages[locale]}
      >
        <LanguageContextProvider value={{ state: this.state }}>
          {children(site)}
        </LanguageContextProvider>
      </IntlProvider>
    )
  }
}

export function useLanguage () {
  const context = useContext(LanguageContext)
  if (context === undefined) {
    throw new Error('useLanguage has to be used within LanguageProvider')
  }
  return context
}

LanguageProvider.propTypes = {
  children: PropTypes.func.isRequired
}

export default LanguageProvider
